import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { DictionaryFuelPriceIndexService } from 'src/app/shared';
import { ErrorDialogComponent } from 'src/components/shared/error-dialog/error-dialog.component';

export interface FuelPriceIndexDialogData {
  name: string;
  errorMessage?: string;
}

@Component({
  selector: 'app-dictionaries-fuel-price-index-add-new-dialog',
  templateUrl: './dictionaries-fuel-price-index-add-new-dialog.component.html',
  styleUrl: './dictionaries-fuel-price-index-add-new-dialog.component.scss',
})
export class DictionariesFuelPriceIndexAddNewDialogComponent {
  FuelPriceIndexForm: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<DictionariesFuelPriceIndexAddNewDialogComponent>,
    private FuelPriceIndexervice: DictionaryFuelPriceIndexService,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: FuelPriceIndexDialogData
  ) {
    this.FuelPriceIndexForm = new FormGroup({
      symbol: new FormControl('', {
        validators: [Validators.required, Validators.maxLength(50)]
      }),
      name: new FormControl('', {
        validators: [Validators.required, Validators.maxLength(50)],
      }),
      uom1: new FormControl('', {
        validators: [Validators.required, Validators.maxLength(5)]
      }),
      uom2: new FormControl('', {
        validators: [Validators.required, Validators.maxLength(5)]
      })
    });
  }

  onAdd() {
    const request = {
      symbol: this.FuelPriceIndexForm.controls.symbol.value,
      name: this.FuelPriceIndexForm.controls.name.value,
      uom1: this.FuelPriceIndexForm.controls.uom1.value,
      uom2: this.FuelPriceIndexForm.controls.uom2.value
    };
    this.FuelPriceIndexervice.add(request).subscribe({
      next: (result) => {
        this.dialogRef.close(result);
      },
      error: (error) => {
        this.handleError(error);
      },
    });
  }

  private handleError(error: any) {
    this.dialog.open(ErrorDialogComponent, {
      data: { message: error.error.Message },
    });
  }
}
